// Game types and interfaces

export interface Cell {
  color: 'white' | 'black' | null;
  isYugo: boolean;
}

export interface GameState {
  board: (Cell | null)[][];
  currentPlayer: 'white' | 'black';
  scores: { white: number; black: number };
  gameStatus: 'waiting' | 'active' | 'finished';
  lastMove: { row: number; col: number; player: 'white' | 'black' } | null;
  players: { white: string; black: string };
  igoLine?: { row: number; col: number }[] | null;
}

export interface MoveHistoryEntry {
  row: number;
  col: number;
  player: 'white' | 'black';
  yugos: number;
  moveNumber: number;
}

export interface User {
  id: string;
  username: string;
  email: string;
  isAdmin?: boolean;
  stats: {
    gamesPlayed: number;
    wins: number;
    losses: number;
  };
}

export interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  isGuest: boolean;
}

export const INITIAL_BOARD: (Cell | null)[][] = Array(8).fill(null).map(() => Array(8).fill(null));

